import { render, staticRenderFns } from "./ButtonSpinner.vue?vue&type=template&id=3a1c2556&scoped=true&lang=pug"
import script from "./ButtonSpinner.vue?vue&type=script&lang=ts"
export * from "./ButtonSpinner.vue?vue&type=script&lang=ts"
import style0 from "./ButtonSpinner.vue?vue&type=style&index=0&id=3a1c2556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1c2556",
  null
  
)

export default component.exports